export default __webpack_public_path__ + "static/game_design-ceabdfea13650408c6bdc9774a32162f.svg";